export default __webpack_public_path__ + "static/media/programs-weight.912facb7.png";